export const categories = [
  {
    id: "movie",
    name: "电影",
    icon: "ri-film-line",
    description: "精选院线大片与经典佳片，涵盖动作、剧情、科幻、喜剧等多元题材，感受大银幕的震撼。",
  },
  {
    id: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    description: "热播剧集与口碑佳作齐上线，都市情感、古装权谋、悬疑推理一应俱全，追剧不停歇。",
  },
  {
    id: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    description: "爆笑综艺与真人秀节目，轻松解压的欢乐时光，明星互动与精彩舞台等你来看。",
  },
  {
    id: "anime",
    name: "动画",
    icon: "ri-robot-2-line",
    description: "国漫日漫与合家欢动画，热血、治愈、冒险应有尽有，找回属于你的童真与感动。",
  },
  {
    id: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    description: "探索自然、人文与历史的纪实影像，跟随镜头看见更大的世界，感受真实的力量。",
  },
  {
    id: "short",
    name: "短视频",
    icon: "ri-video-line",
    description: "短小精悍的创意视频合集，美食、萌宠、科普、旅行，碎片时间也能收获满满快乐。",
  },
];

export const regions = ["全部", "中国大陆", "美国", "日本", "韩国", "英国", "法国", "中国香港"];

export const years = ["全部", "2024", "2023", "2022", "2021"];

export const sortOptions = [
  { value: "default", label: "默认排序" },
  { value: "newest", label: "最新上传" },
  { value: "hot", label: "播放最多" },
];